'use client';

import { useEffect } from 'react';

const isPremiumClient = (): boolean =>
  typeof window !== 'undefined' && window.__isPremiumUser === true;

interface NextAkceloAdAreaProps {
  slotId: string;
  adUnitClass: string;
  desktopHeight?: number;
  mobileHeight?: number;
}

export const NextAkceloAdArea = ({
  slotId,
  adUnitClass,
  desktopHeight = 360,
  mobileHeight = 180,
}: NextAkceloAdAreaProps) => {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const displayedSlots = ((
      window as Window & {
        __akceloDisplayedSlots?: Set<string>;
      }
    ).__akceloDisplayedSlots ||= new Set<string>());

    if (displayedSlots.has(slotId)) {
      return;
    }

    if (!document.getElementById(slotId)) {
      return;
    }

    window.slmadshb = window.slmadshb || { que: [], display: () => undefined };
    window.slmadshb.que = window.slmadshb.que || [];
    window.slmadshb.que.push(() => {
      window.slmadshb?.display(slotId);
      displayedSlots.add(slotId);
    });
  }, [slotId]);

  if (process.env.NEXT_PUBLIC_ENABLE_AKCELO !== 'true') {
    return null;
  }

  if (typeof window === 'undefined') {
    return null;
  }

  if (isPremiumClient()) {
    return null;
  }

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          .${adUnitClass} {
            width: 100%;
            height: ${desktopHeight}px;
          }
          @media (pointer:coarse) {
            .${adUnitClass} {
              width: 100%;
              height: ${mobileHeight}px;
            }
          }
        `,
        }}
      />
      <div className={`akcelo-wrapper akcelo-video ${adUnitClass}`}>
        <div id={slotId} />
      </div>
    </>
  );
};
